import { FetchApiError } from '@/modules/fetch-core';
import { isGatewayStatus } from '@/modules/backend-down-signal';
import { showNotification } from '@/modules/show-notification';

// Error toast for a failed API action. During a gateway outage (502/503 —
// the backend redeploying, banner already up) a generic "something went
// wrong" reads as a broken app, so the gateway case gets its own honest
// copy; everything else falls back to the caller's generic text.
export function notifyApiError(
  error: unknown,
  genericText = 'Something went wrong, try again',
): void {
  const status =
    error instanceof FetchApiError ? error.extra.status : undefined;
  showNotification(
    'error',
    typeof status === 'number' && isGatewayStatus(status) ?
      'We’re updating Score Arena — try again in a moment'
    : genericText,
  );
}
